import React from "react";
import ReactDOM from "react-dom";
import "../../styles/modal.scss";
import "../../styles/suport.scss";
import {
  showModal,
  hideModal,
  ShowInfo,
  msg,
  setFocus,
  formatNumber,
  getValue,
  genId,
  div,
  formatMoney,
  ShowAlert,
  formId,
  formatDate,
  getSource,
  compareObject,
  UnSubscribe,
  Subscribe,
} from "../../components/utilities";
import { ALERT001, ALERT002 } from "../../components/msg";
import { Reference } from "./listReferences";
import { Textarea, User, Count } from "../../components/inputs";
import { Cellar } from "./listCellars";
import ComponentMovements from "./components/componentMovements";
import ModalHeaderSuport from "../../components/modalHeaderSuport";
import ModalFooterSuport from "../../components/modalFooterSuport";
import ModalHeader from "../../components/modalHeader";
import ModalFooter from "../../components/modalFooter";
import ModalReference from "./modalReference";
import Td from "../../components/td";
import DateTime from "../../components/dateTime";
import { Api as Warehouse } from "../../services/warehouse";
import { connect } from "react-redux";

class ModalInventory extends React.Component {
  constructor(props) {
    super(props);
    const data = this.handleScheme(props.data);
    this.state = {
      form: "__ModalInventory",
      _id: "__ModalInventory",
      title: "Inventario",
      name: "initial",
      show: false,
      old: data,
      data: data,
      isNew: props.isNew || false,
      change: false,
      select: { _id: "", caption: "" },
      printParams: {
        project_id: "-1",
        _class: "SUPORT-WAREHOUSE-INITIAL",
        _id: "-1",
        single: true,
      },
    };
  }

  handleScheme = (data) => {
    const now = new Date();
    return {
      date_of: formatDate(now, "yyyy-MM-dd HH:mm:ss"),
      project_id: this.props.project_id,
      _class: "SUPORT-WAREHOUSE-ENTRY",
      _state: "0",
      _id: genId("-1"),
      code: "",
      caption: "Inventario",
      description: "",
      observations: "",
      warehouse_id: "-1",
      cellar_id: getValue(data, "cellar_id", "-1"),
      _operation: 1,
      document_tp: getValue(data, "document_tp", "-1"),
      document_id: getValue(data, "document_id", "-1"),
      cost: 0,
      details: [],
      movements: [],
      _data: {
        project: this.props.project,
        cellar: getValue(data, "cellar", ""),
        document_code: getValue(data, "document_code", ""),
        document_type: "",
        proveedor_id: "-1",
        destino: "",
        realizo_id: this.props.user_id,
        realizo: this.props.user_name,
        reviso_id: "-1",
        reviso: "",
        aprobo_id: "-1",
        aprobo: "",
        username: "",
      },
      next_id: "-1",
      prior_id: "-1",
    };
  };

  eventSetData = (e) => {
    setTimeout(() => {
      this.handleUpdate(e);
    }, 500);
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
      change: true,
    });
  };

  handleChangeDate = (e) => {
    const value = formatDate(e.target.value, "yyyy-MM-dd HH:mm:ss");
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: value,
      },
      change: true,
    });
  };

  handleChangeCellar = (e) => {
    const data = this.state.data;
    const id = data._id;
    if (this.state.isNew || id === "-1") {
      this.handleGetDetails({ _id: id, cellar_id: e._id }).then((result) => {
        data.details = result.list;
        this.setState({
          data: {
            ...this.state.data,
            cellar_id: getValue(e, "_id", "-1"),
            details: data.details,
            _data: {
              ...this.state.data._data,
              cellar: getValue(e, "caption", ""),
            },
          },
          change: true,
        });
      });
    } else {
      this.setState({
        data: {
          ...this.state.data,
          cellar_id: getValue(e, "_id", "-1"),
          _data: {
            ...this.state.data._data,
            cellar: getValue(e, "caption", ""),
          },
        },
        change: true,
      });
    }
  };

  handleChangeRealizo = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        _data: {
          ...this.state.data._data,
          realizo_id: getValue(e, "_id", "-1"),
          realizo: getValue(e, "caption", ""),
        },
      },
      change: true,
    });
  };

  handleChangeAprobo = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        _data: {
          ...this.state.data._data,
          aprobo_id: getValue(e, "_id", "-1"),
          aprobo: getValue(e, "caption", ""),
        },
      },
      change: true,
    });
  };

  handleChangeReviso = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        _data: {
          ...this.state.data._data,
          reviso_id: getValue(e, "_id", "-1"),
          reviso: getValue(e, "caption", ""),
        },
      },
      change: true,
    });
  };

  handleChangeDetail = (e) => {
    let details = this.state.data.details;
    details[e.index] = e.item;
    this.setState({
      data: {
        ...this.state.data,
        details: details,
      },
      change: true,
    });
  };

  handleChangeDetailInput = (e) => {
    let details = this.state.data.details;
    let index = details.indexOf((select) => select._id === e.item._id);
    if (index === -1) {
      details.push(e.item);
    } else {
      details[index] = e.item;
    }
    this.setState({
      data: {
        ...this.state.data,
        details: details,
      },
      change: true,
    });
  };

  handleChangeSelect = (e) => {
    this.setState({ select: e });
  };

  handleExecute = (e) => {
    const _state = this.props._state || "0";
    if (typeof this.props.onSetData === "function" && _state === "0") {
      this.props.onSetData(e);
    }
  };

  handleHide = () => {
    hideModal(this.state._id);
    this.setState({ show: false });
  };

  handleShow = () => {
    const _state = this.props._state || "0";
    if (_state === "main_not_exist") {
      ShowAlert(ALERT001);
    } else {
      if (this.props.isFind) {
        const _id = getValue(this.props, "_id", "-1");
        if (_id !== "-1") {
          const form_id = formId(`${this.state.form}${_id}`);
          this.setState({ _id: form_id, show: true, change: false });
        }
      } else if (this.props.isNew) {
        const form_id = `${this.state.form}${Date.now()}`;
        this.setState({ _id: form_id, show: true, change: false });
      } else {
        const _id = getValue(this.props.data, "_id", "-1");
        if (_id !== "-1") {
          const form_id = formId(`${this.state.form}${_id}`);
          this.setState({ _id: form_id, show: true, change: false });
        }
      }
    }
  };

  handleClose = (e) => {
    if (this.state.change && e) {
      this.handleOk();
    } else {
      this.handleHide();
    }
  };

  handleOk = () => {
    if (this.state.change) {
      const id = this.state.data._id;
      const params = this.state.data;
      Warehouse.setInventory(id, params).then((result) => {
        if (result.msg === "") {
          const data = result.data;
          this.handleSetData({ data, isNew: false, change: false });
          this.handleExecute(data);
        }
      });
    } else {
      this.handleHide();
    }
  };

  handleState = (e) => {
    if (this.state.change) {
      ShowAlert(ALERT002);
    } else {
      const _state = getValue(this.state.data, "_state");
      if (_state !== e) {
        const id = getValue(this.state.data, "_id");
        Warehouse.stateInventory(id, e).then((result) => {
          if (result.msg === "") {
            const data = result.data;
            this.handleSetData({ data, isNew: false, change: false });
            this.handleExecute(data);
          }
        });
      }
    }
  };

  handlePrior = (e) => {
    const _id = getValue(this.state.data, "prior_id", "-1");
    if (_id === "-1") {
      ShowInfo(msg("MSG-FIRST-ROW"));
    } else {
      this.handleFind(_id);
    }
  };

  handleNext = (e) => {
    const _id = getValue(this.state.data, "next_id", "-1");
    if (_id === "-1") {
      ShowInfo(msg("MSG-END-ROW"));
    } else {
      this.handleFind(_id);
    }
  };

  handleSetData = (e) => {
    this.setState({
      old: e.data,
      data: e.data,
      isNew: e.isNew,
      change: e.change,
      tabs: [],
      printParams: {
        project_id: e.data.project_id,
        _class: e.data._class,
        _id: e.data._id,
        single: true,
      },
    });
    showModal(this.state._id);
    setFocus(`${this.state._id}_caption`, e.focusInt);
  };

  handleUpdate = (e) => {
    if (compareObject(this.state.data, e)) {
      this.handleSetData({
        data: e,
        isNew: false,
        change: false,
      });
    }
  };

  handleData = () => {
    const _id = getSource(this.props.data, ["_id"], "-1");
    if (_id === "-1") {
      this.handleSetData({ data: this.props.data, isNew: false, change: false });
    } else {
      this.handleFind(_id);
    }
  };

  handleGetDetails = (e) => {
    const _id = e._id;
    const cellar_id = e.cellar_id;
    return Warehouse.cellarInventory(_id, cellar_id).then((result) => {
      return result.data;
    });
  };

  handleNew = () => {
    const data = this.handleScheme(this.props.data);
    this.handleGetDetails({ _id: data._id, cellar_id: data.cellar_id }).then((result) => {
      data.details = result.list;
      this.handleSetData({
        data,
        isNew: true,
        change: true,
        focusInt: true,
      });
    });
  };

  handleFind = (id) => {
    if (this.state.change) {
      ShowInfo(msg("MSG-CHANGE"));
    } else if (id !== "-1") {
      Warehouse.inventory(id, this.props.project_id).then((result) => {
        if (result.msg === "") {
          const data = result.data;
          this.handleSetData({ data, isNew: false, change: false, focusInt: true });
        }
      });
    }
  };

  componentDidMount() {
    Subscribe(`${this.state.data._class}/${this.state.data._id}`, (event) => this.eventSetData(event));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show) {
      if (prevState.data._id !== this.state.data._id) {
        UnSubscribe(`${prevState.data._class}/${prevState.data._id}`, (event) => this.eventSetData(event));
        Subscribe(`${this.state.data._class}/${this.state.data._id}`, (event) => this.eventSetData(event));
      }
      if (prevState.show !== this.state.show) {
        if (this.props.isNew) {
          this.handleNew();
        } else if (this.props.isFind) {
          this.handleFind(this.props._id);
        } else {
          this.handleData();
        }
      }
    }
  }

  componentWillUnmount() {
    UnSubscribe(`${this.state.data._class}/${this.state.data._id}`, (event) => this.eventSetData(event));
    hideModal(this.state._id);
  }

  render() {
    if (!this.state.show) {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
          {ReactDOM.createPortal(
            <div className="modal fade" id={this.state._id} role="dialog">
              <div className="modal-dialog __modalObject sm" role="document">
                <div className="modal-content">
                  <ModalHeaderSuport
                    title={this.state.data.caption}
                    _state={this.state.data._state}
                    _id={this.state.data._id}
                    isNew={this.state.isNew}
                    authorized={this.state.data.authorized}
                    alerts={this.state.data.alerts}
                    change={this.state.change}
                    handleClose={this.handleClose}
                    handlePrior={this.handlePrior}
                    handleNext={this.handleNext}
                  />
                  <div className="modal-body-tabs">
                    <nav>
                      <div className="nav nav-tabs" role="tablist">
                        <a
                          className="nav-item nav-link active"
                          id={`${this.state._id}-nav-1-tab`}
                          data-toggle="tab"
                          href={`#${this.state._id}-nav-1`}
                          role="tab"
                          aria-selected="true"
                        >
                          General
                        </a>
                        <a
                          className="nav-item nav-link"
                          id={`${this.state._id}-nav-2-tab`}
                          data-toggle="tab"
                          href={`#${this.state._id}-nav-2`}
                          role="tab"
                          aria-selected="false"
                        >
                          Movimientos
                        </a>
                      </div>
                    </nav>
                    <div className="tab-content modal">
                      <div
                        className="tab-pane fade show active"
                        id={`${this.state._id}-nav-1`}
                        role="tabpanel"
                        aria-labelledby={`${this.state._id}-nav-1-tab`}
                      >
                        <div className="suport">
                          <div className="suport-group">
                            <Td className="suport-row" cols="90px auto 90px 230px">
                              <div className="suport-td caption">Bodega</div>
                              <div className="suport-td">
                                <Cellar
                                  className="form-control sp ctr-sm t-m"
                                  classNameBtn="input-group-text sp"
                                  project_id={this.state.data.project_id}
                                  _state={this.state.data._state}
                                  select={{
                                    _id: this.state.data.cellar_id,
                                    caption: this.state.data._data.cellar,
                                  }}
                                  onChange={this.handleChangeCellar}
                                />
                              </div>
                              <div className="suport-td caption">Inventario</div>
                              <div className="suport-td">
                                <DateTime
                                  className="form-control sp form-control-sm t-c"
                                  popperClassName="datepicker-right"
                                  name="date_of"
                                  value={this.state.data.date_of}
                                  _state={this.state.data._state}
                                  onChange={this.handleChangeDate}
                                  placeholder="Fecha de despacho"
                                  dateFormat="MMMM d, yyyy"
                                />
                              </div>
                            </Td>
                            <Td className="suport-row" cols="90px auto 90px 230px">
                              <div className="suport-td caption">Autorizo</div>
                              <div className="suport-td">
                                <User
                                  className="form-control sp ctr-sm t-m"
                                  classNameBtn="input-group-text sp"
                                  project_id={this.state.data.project_id}
                                  _state={this.state.data._state}
                                  select={{
                                    _id: this.state.data._data.aprobo_id,
                                    caption: this.state.data._data.aprobo,
                                  }}
                                  onChange={this.handleChangeAprobo}
                                />
                              </div>
                              <div className="suport-td caption">Total</div>
                              <div className="suport-td value">{formatMoney(this.state.data.cost)}</div>
                            </Td>
                            <Td className="suport-row" cols="90px auto 90px 230px">
                              <div className="suport-td caption">Realizo</div>
                              <div className="suport-td">
                                <User
                                  className="form-control sp ctr-sm t-m"
                                  classNameBtn="input-group-text sp"
                                  project_id={this.state.data.project_id}
                                  _state={this.state.data._state}
                                  select={{
                                    _id: this.state.data._data.realizo_id,
                                    caption: this.state.data._data.realizo,
                                  }}
                                  onChange={this.handleChangeRecibio}
                                />
                              </div>
                              <div className="suport-td caption">Revisó</div>
                              <div className="suport-td">
                                <User
                                  className="form-control sp ctr-sm t-m"
                                  classNameBtn="input-group-text sp"
                                  project_id={this.state.data.project_id}
                                  _state={this.state.data._state}
                                  select={{
                                    _id: this.state.data._data.reviso_id,
                                    caption: this.state.data._data.reviso,
                                  }}
                                  onChange={this.handleChangeReviso}
                                />
                              </div>
                            </Td>
                          </div>
                          <ComponentDetails
                            _id={this.state._id}
                            data={this.state.data}
                            select={this.state.select}
                            changeDetail={this.handleChangeDetail}
                            changeDetailInput={this.handleChangeDetailInput}
                            changeSelect={this.handleChangeSelect}
                          />
                          <div className="suport-group">
                            <Td className="suport-row" cols="auto">
                              <div className="suport-td d">
                                <Textarea
                                  className="form-control sp notresize"
                                  _state={this.state.data._state}
                                  rows={4}
                                  name="observations"
                                  value={this.state.data.observations}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </Td>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id={`${this.state._id}-nav-2`}
                        role="tabpanel"
                        aria-labelledby={`${this.state._id}-nav-2-tab`}
                      >
                        <ComponentMovements
                          _state={this.state.data._state}
                          rows={30}
                          _operation={this.state.data._operation}
                          movements={this.state.data.movements}
                        />
                      </div>
                    </div>
                  </div>
                  <ModalFooterSuport
                    data={this.state.data}
                    change={this.state.change}
                    _state={this.state.data._state}
                    send={false}
                    isNew={this.state.isNew}
                    printParams={this.state.printParams}
                    handleState={this.handleState}
                    handleNew={this.handleNew}
                    handleClose={this.handleClose}
                    handleOk={this.handleOk}
                  />
                </div>
              </div>
            </div>,
            document.getElementById("rootModals")
          )}
        </React.Fragment>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    signin: state.sistem.signin,
    project_id: state.sistem.project._id || "-1",
    project: state.sistem.project,
    user_id: state.sistem.profile._id || "-1",
    user_name: state.sistem.profile.caption || "",
    _view: state.sistem.folder._view || "",
    online: state.sistem.online,
  };
}

export default connect(mapStateToProps)(ModalInventory);

class ModalDetail extends React.Component {
  constructor(props) {
    super(props);
    const data = this.handleScheme(this.props.data);
    this.state = {
      _id: "__modalInventoryDetail",
      title: "Detalle",
      show: false,
      old: data,
      data: data,
      change: false,
    };
  }

  handleScheme = (data) => {
    let _id = getValue(data, "_id", "-1");
    _id = genId(_id);
    data._id = _id;
    return data;
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
      change: true,
    });
  };

  handleChangeCount = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.name]: e.value,
      },
      change: true,
    });
  };

  handleExecute = (e) => {
    if (typeof this.props.onSetData === "function") {
      this.props.onSetData({ index: this.props.index, item: e });
    }
    this.handleHide();
  };

  handleSelect = (e) => {
    if (typeof this.props.changeSelect === "function") {
      this.props.changeSelect(e);
    }
  };

  handleHide = () => {
    hideModal(this.state._id);
    this.setState({ show: false });
  };

  handleShow = () => {
    this.setState({
      show: true,
      change: false,
    });
  };

  handleClose = () => {
    if (this.state.change) {
      this.setState({ data: this.state.old, change: false });
    }
    this.handleHide();
  };

  handleOk = () => {
    if (this.state.change) {
      this.handleExecute(this.state.data);
    } else {
      this.handleHide();
    }
  };

  handleData = () => {
    this.setState({ change: false });
    this.handleSelect(this.state.data);
    showModal(this.state._id);
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show) {
      if (prevState.show !== this.state.show) {
        this.handleData();
      }
    }
  }

  render() {
    if (!this.state.show) {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
          {ReactDOM.createPortal(
            <div className="modal fade" id={this.state._id} role="dialog">
              <div className="modal-dialog xs" role="dialog">
                <div className="modal-content">
                  <ModalHeader
                    title={`${this.state.title}${this.state.data.code === "" ? "" : " - "}${this.state.data.code}`}
                    handleClose={this.handleClose}
                  />
                  <div className="modal-body">
                    <div className="modal-box">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group input-group-sm">
                            <label>Referencia</label>
                            <div
                              className="form-control textarea"
                              placeholder="Referencia"
                              project_id={this.props.project_id}
                              _state={this.props._state}
                              select={{
                                _id: this.state.data.reference_id,
                                code: this.state.data.code,
                                caption: this.state.data.description,
                              }}
                            >
                              {this.state.data.description}
                            </div>
                          </div>
                          <div className="form-group input-group-sm">
                            <label>Existencia</label>
                            <Count
                              id={`${this.state._id}_caption`}
                              className="input-group input-group-sm"
                              _state={this.props._state}
                              write={false}
                              unity={this.state.data.unity}
                              value={this.state.data.stock}
                            />
                          </div>
                          <div className="form-group input-group-sm">
                            <label>Inventario</label>
                            <Count
                              className="input-group input-group-sm"
                              _state={this.props._state}
                              name="quantity"
                              unity={this.state.data.unity}
                              value={this.state.data.quantity}
                              increase={1}
                              handleValue={this.handleChangeCount}
                            />
                          </div>
                          <div className="form-group input-group-sm">
                            <label>Costo</label>
                            <Count
                              className="input-group input-group-sm"
                              _state={this.props._state}
                              name="cost"
                              unity="$"
                              value={this.state.data.cost}
                              increase={1000}
                              precision={2}
                              handleValue={this.handleChangeCount}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <ModalFooter
                      title="¿Retirar detalle?"
                      description="¿Desea retirar el detalle de la compra? este cambio no podrá revertirse."
                      _state={this.props._state}
                      onClose={this.handleClose}
                      onOk={this.handleOk}
                    />
                  </div>
                </div>
              </div>
            </div>,
            document.getElementById("rootModals")
          )}
        </React.Fragment>
      );
    }
  }
}

class ModalInput extends React.Component {
  constructor(props) {
    super(props);
    const data = this.handleScheme();
    this.state = {
      _id: "__modalInventoryInput",
      title: "Detalle",
      show: false,
      old: data,
      data: data,
      change: false,
    };
  }

  handleScheme = () => {
    return {
      document_id: this.props.document_id,
      _state: "0",
      _id: genId("-1"),
      cellar_id: this.props.cellar_id || "-1",
      reference_id: "-1",
      code: "",
      description: "",
      unity: "und",
      main_id: "-1",
      stock: 0,
      quantity: 0,
      adjustment: 0,
      unitary: 0,
      cost: 0,
      _data: {
        code: "",
        description: "",
        stock: 0,
        username: "",
      },
    };
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
      change: true,
    });
  };

  handleChangeReference = (e) => {
    let method_tp = getValue(e, "method_tp", "KARDEX_METHOD_TP00");
    let main_id = "-1";
    if (method_tp !== "KARDEX_METHOD_TP00") {
      main_id = this.state.data._id;
    }
    this.setState({
      data: {
        ...this.state.data,
        reference_id: getValue(e, "_id", "-1"),
        code: getValue(e, "code", ""),
        description: getValue(e, "caption", ""),
        unity: getValue(e, "unity", ""),
        main_id: main_id,
        _data: {
          ...this.state.data._data,
          code: getValue(e, "code", ""),
          description: getValue(e, "caption", ""),
        },
      },
      change: true,
    });
  };

  handleChangeValue = (e) => {
    const value = Number(e.value);
    this.setState({
      data: {
        ...this.state.data,
        [e.name]: value,
      },
      change: true,
    });
  };

  handleExecute = (e) => {
    if (typeof this.props.onSetData === "function") {
      this.props.onSetData({ index: this.props.index, item: e });
    }
    this.handleHide();
  };

  handleSelect = (e) => {
    if (typeof this.props.changeSelect === "function") {
      this.props.changeSelect(e);
    }
  };

  handleHide = () => {
    hideModal(this.state._id);
    this.setState({ show: false });
  };

  handleShow = () => {
    this.setState({
      show: true,
      change: false,
    });
  };

  handleClose = () => {
    if (this.state.change) {
      this.setState({ data: this.state.old, change: false });
    }
    this.handleHide();
  };

  handleOk = () => {
    if (this.state.change) {
      this.handleExecute(this.state.data);
    } else {
      this.handleHide();
    }
  };

  handleData = () => {
    const data = this.handleScheme();
    this.setState({ data, old: data, change: false });
    this.handleSelect(data);
    showModal(this.state._id);
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show) {
      if (prevState.show !== this.state.show) {
        this.handleData();
      }
    }
  }

  render() {
    if (!this.state.show) {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
          {ReactDOM.createPortal(
            <div className="modal fade" id={this.state._id} role="dialog">
              <div className="modal-dialog xs" role="dialog">
                <div className="modal-content">
                  <ModalHeader
                    title={`${this.state.title}${this.state.data.code === "" ? "" : " - "}${this.state.data.code}`}
                    handleClose={this.handleClose}
                  />
                  <div className="modal-body">
                    <div className="modal-box">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group input-group-sm">
                            <label>
                              <ModalReference
                                className="link"
                                isFind={true}
                                project_id={this.props.project_id}
                                _id={this.state.data.reference_id}
                                onSetData={this.handleChangeReference}
                              >
                                Referencia
                              </ModalReference>
                            </label>
                            <Reference
                              className="form-control textarea"
                              placeholder="Referencia"
                              project_id={this.props.project_id}
                              _state={this.props._state}
                              select={{
                                _id: this.state.data.reference_id,
                                code: this.state.data.code,
                                caption: this.state.data.description,
                              }}
                              onChange={this.handleChangeReference}
                            />
                          </div>
                          <div className="form-group input-group-sm">
                            <label>Inventario</label>
                            <Count
                              id={`${this.state._id}_caption`}
                              className="input-group input-group-sm"
                              _state={this.props._state}
                              name="quantity"
                              unity={this.state.data.unity}
                              value={this.state.data.quantity}
                              increase={1}
                              handleValue={this.handleChangeValue}
                            />
                          </div>
                          <div className="form-group input-group-sm">
                            <label>Costo</label>
                            <Count
                              className="input-group input-group-sm"
                              _state={this.props._state}
                              name="cost"
                              unity="$"
                              value={this.state.data.cost}
                              increase={1000}
                              precision={0}
                              handleValue={this.handleChangeValue}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <ModalFooter
                      title="¿Retirar detalle?"
                      description="¿Desea retirar el detalle de la compra? este cambio no podrá revertirse."
                      _state={this.props._state}
                      onClose={this.handleClose}
                      onOk={this.handleOk}
                    />
                  </div>
                </div>
              </div>
            </div>,
            document.getElementById("rootModals")
          )}
        </React.Fragment>
      );
    }
  }
}

function ComponentDetails(props) {
  const _id = props._id;
  const data = props.data;
  const details = data.details;
  const select = props.select || { _id: "", caption: "" };

  return (
    <React.Fragment>
      <div className="suport-group" style={{ marginBottom: "20px" }}>
        <Td className="suport-head" cols="110px 95px 35px auto 115px 134px">
          <div className="suport-td">Referencia</div>
          <div className="suport-td">Existencia</div>
          <div className="suport-td">Und</div>
          <div className="suport-td">Descripción</div>
          <div className="suport-td">Inventario</div>
          <div className="suport-td">Costo</div>
        </Td>
        <div className="suport-scroll" id={`${_id}_scroll`}>
          {details.map((item, i) => {
            return (
              <Td
                key={i}
                className={`${data._state === "0" ? "suport-item" : "suport-item disabled"} ${
                  item.stock < 0 ? "negative" : ""
                } ${item._id === select._id ? "active" : ""}`}
                cols="35px 75px 95px 35px auto 115px 130px"
              >
                <div className="suport-td t-c">{i + 1}</div>
                <div className="suport-td t-c">{item.code}</div>
                <div className="suport-td t-r">{formatNumber(item.stock)}</div>
                <div className="suport-td t-c">{item.unity}</div>
                <div className="suport-td">{item.description}</div>
                <div className="suport-td t-r">{formatNumber(item.quantity)}</div>
                <div className="suport-td t-r bt">
                  {formatMoney(item.cost)}
                  <ModalDetail
                    className="input-group-text sp"
                    project_id={data.project_id}
                    document_id={data._id}
                    cellar_id={data.cellar_id}
                    _state={data._state}
                    index={i}
                    data={item}
                    onSetData={props.changeDetail}
                    changeSelect={props.changeSelect}
                  >
                    <i className="fa fa-ellipsis-h"></i>
                  </ModalDetail>
                </div>
              </Td>
            );
          })}
          <Td className="suport-item" cols="35px 75px 95px 35px auto 115px 130px">
            <div className="suport-td t-c">{details.length + 1}</div>
            <div className="suport-td t-c"></div>
            <div className="suport-td t-r"></div>
            <div className="suport-td t-c"></div>
            <div className="suport-td"></div>
            <div className="suport-td t-r"></div>
            <div className="suport-td t-r bt">
              <ModalInput
                className="input-group-text sp"
                project_id={data.project_id}
                document_id={data._id}
                cellar_id={data.cellar_id}
                _state={data._state}
                index={details.length + 1}
                onSetData={props.changeDetailInput}
                changeSelect={props.changeSelect}
              >
                <i className="fa fa-ellipsis-h"></i>
              </ModalInput>
            </div>
          </Td>
        </div>
      </div>
    </React.Fragment>
  );
}
